<style>
  .example-spacer {
    flex: 1 1 auto;
  }

  .nav-shape {
    position: relative;
    border: none;
    width: 236px;
    height: auto;
    border-right: 60px solid transparent;
    border-top: 80px solid #fff;
  }

  .logo {
    position: absolute;
    left: 5%;
    top: 15px;
    z-index: 10;
  }
</style>
<mat-toolbar
  style="background: linear-gradient(90deg, #fff 10%, #008acc 10%, #002449 100%); padding-left: 5%;padding-right: 5%; height: 80px;">
  <span>
    <a href="https://bancodeoccidente.com.co">
      <svg class="logo" version="1.1" width="200" w="" id="Capa_3" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 633 132.3"
        style="enable-background:new 0 0 633 132.3;" xml:space="preserve">
        <style type="text/css">
          .st0 {
            clip-path: url(#SVGID_2_);
            fill: #112C46;
          }

          .st1 {
            fill: #008ACC;
          }

          .st2 {
            clip-path: url(#SVGID_4_);
            fill: #008ACC;
          }

          .st3 {
            fill: #0082C2;
          }

          .st4 {
            clip-path: url(#SVGID_6_);
            fill: #008ACC;
          }
        </style>
        <g>
          <defs>
            <rect id="SVGID_1_" x="5.5" y="6.3" width="614.1" height="118.8"></rect>
          </defs>
          <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_" style="overflow:visible;"></use>
          </clipPath>
          <path class="st0"
            d="M244.6,78.7c-3.1,0.6-6.3,1-8,1c-5.7,0.3-6.7-2.1-6.7-10.4c0-8.3,1.1-10.7,6.7-10.4c1.7,0.1,5.3,0.8,8,1.1
        l0.8-4.8c-2.6-0.5-6.1-1.1-8.5-1.2c-12.6-0.6-15.6,4.7-15.6,15.4c0,10.6,3.1,15.8,15.6,15.4c2.6-0.1,6-0.6,8.7-1.1L244.6,78.7z">
          </path>
          <path class="st0" d="M130.9,65.9v12.4h9.5c4.5,0,6.6-1.2,6.6-6.7c0-5.7-4.1-5.8-7.1-5.8H130.9z M130.9,48.5v11.6h9
        c4.1,0,5.6-1.7,5.6-6.3c0-4.2-1.4-5.3-6.2-5.3L130.9,48.5z M139.4,42.7c9.2,0,14.6,3.8,14.6,11.1c0,4.4-1.5,7.1-3.9,8.8
        c2.9,1.5,5.5,4.1,5.5,9.1c0,9.5-6.7,12.5-15.1,12.5h-17.9V42.7H139.4z"></path>
          <path class="st0" d="M176.3,69.6c0,0-2.7,0-5.5,0.3c-2.8,0.4-4.4,1.8-4.4,4.7c0,2.2,0.7,4.1,3.7,4.7c1.9,0.4,3.9,0.3,6.2,0V69.6z
          M160.6,55.6c4.9-1,8.4-1.7,12-1.7c8.3,0,12.1,3.9,12.1,9.9v19.9c-5.1,0.6-10.2,1.2-15.8,0.6c-6.9-0.7-11.1-4.2-11.1-9.8
        c0-5,3-8.6,10.9-9.5c3.4-0.4,7.6-0.4,7.6-0.4v-1.1c0-3.1-1.1-4.5-3.8-4.5c-2.9,0-6.4,0.7-11.1,1.6L160.6,55.6z">
          </path>
          <path class="st0" d="M267.8,68.8c0-7.6-2.5-9.9-6.5-9.9c-5,0-6.8,1.7-6.8,9.8c0,8.6,1.2,10.9,6.8,10.9
        C266.8,79.6,267.8,76.9,267.8,68.8 M261.3,54c9.4,0,15,4.6,15,14.9c0,10.3-3.1,15.8-15,15.8c-11.8,0-15.3-4.8-15.3-15.9
        C246,58.3,251,54,261.3,54"></path>
          <path class="st0" d="M310.2,59.3c-1.4-0.4-3.6-0.7-5.7-0.4c-4.2,0.6-5.2,2.9-5.2,9.9c0,7.3,0.9,10.4,7,10.8
        c2.5,0.1,3.9-0.1,3.9-0.1V59.3z M310.2,42.7h8.3v41.2c-4.6,0.5-7.6,0.7-11,0.7c-14,0-16.9-5.8-16.9-16c0-9.1,3.2-14.8,13.8-14.8
        c2.2,0,4.1,0.2,5.7,0.4V42.7z"></path>
          <path class="st0" d="M342.3,66.7c-0.2-5.9-1.9-7.7-5.9-7.7c-3.8,0-5.5,1.8-5.7,7.7L342.3,66.7z M349.6,83.2
        c-4.5,1-8.7,1.5-12.8,1.5c-12.4,0-14.9-6.5-14.9-15.4c0-11.3,5.2-15.3,14.1-15.3c9.6,0,14.6,4.5,14.6,14.3v3.4h-20.1
        c0.2,5.5,1.4,7.9,6.2,7.9c2.8,0,8.8-0.8,11.8-1.4L349.6,83.2z"></path>
          <path class="st0" d="M189.1,56.9c4.8-1.9,9.2-3,14.3-3c10.7,0,14.4,5.2,14.4,14.8V84h-8.4V68.7c0-7.3-1.6-9.8-6.1-9.8
        c-2.2,0-4.6,0.5-6,0.9V84h-8.2V56.9z"></path>
        </g>
        <polygon class="st1" points="5.5,78.3 52.3,125 99.1,78.3 88.2,67.4 52.3,103.3 27.3,78.3 52.3,53.3 63,63.9 73.8,53.1 52.3,31.5
      "></polygon>
        <polygon class="st1"
          points="52.3,6.3 5.5,53.1 16.4,63.9 52.3,28 77.3,53.1 52.3,78.1 41.6,67.4 30.8,78.3 52.3,99.8 99.1,53.1 ">
        </polygon>
        <g>
          <defs>
            <rect id="SVGID_3_" x="5.5" y="6.3" width="614.1" height="118.8"></rect>
          </defs>
          <clipPath id="SVGID_4_">
            <use xlink:href="#SVGID_3_" style="overflow:visible;"></use>
          </clipPath>
          <path class="st2"
            d="M456.3,78.7c-3.1,0.6-6.3,1-8,1c-5.7,0.3-6.7-2.1-6.7-10.4c0-8.3,1.1-10.7,6.7-10.4c1.7,0.1,5.3,0.8,8,1.1
        l0.8-4.8c-2.6-0.5-6.1-1.1-8.5-1.2c-12.6-0.6-15.6,4.7-15.6,15.4c0,10.6,3.1,15.8,15.6,15.4c2.6-0.1,6-0.6,8.7-1.1L456.3,78.7z">
          </path>
          <path class="st2"
            d="M430.7,78.7c-3.1,0.6-6.3,1-8,1C417,80,416,77.6,416,69.3c0-8.3,1.1-10.7,6.7-10.4c1.7,0.1,5.3,0.8,8,1.1
        l0.8-4.8c-2.6-0.5-6.1-1.1-8.5-1.2c-12.6-0.6-15.6,4.7-15.6,15.4c0,10.6,3.1,15.8,15.6,15.4c2.6-0.1,6-0.6,8.7-1.1L430.7,78.7z">
          </path>
          <path class="st2" d="M384.7,78.8c9.2,0,10.8-4.6,10.8-16c0-11-4.1-14.7-10.8-14.7c-8.1,0-11.1,3-11.1,14.6
        C373.5,74.9,375.4,78.8,384.7,78.8 M404.1,62.7c0,14.4-3.8,21.8-19.4,21.8c-15.5,0-19.7-6.5-19.7-22c0-14.6,6.2-20.3,19.7-20.3
        C397,42.2,404.1,48.4,404.1,62.7"></path>
        </g>
        <path class="st3" d="M461.2,54.5h8.2v29.6h-8.2V54.5z M461.2,43.8h8.2V50h-8.2V43.8z"></path>
        <g>
          <defs>
            <rect id="SVGID_5_" x="5.5" y="6.3" width="614.1" height="118.8"></rect>
          </defs>
          <clipPath id="SVGID_6_">
            <use xlink:href="#SVGID_5_" style="overflow:visible;"></use>
          </clipPath>
          <path class="st4" d="M493.1,59.3c-1.4-0.4-3.6-0.7-5.7-0.4c-4.2,0.6-5.2,2.9-5.2,9.9c0,7.3,0.9,10.5,7,10.8c0.4,0,0.9,0,1.5,0
        c0.7,0,1.7-0.1,2.4-0.1V59.3z M493.1,42.7h8.3v41.2c-4.7,0.4-7.6,0.7-10.9,0.7c-14,0-16.9-5.8-16.9-16c0-9.1,3.2-14.8,13.8-14.8
        c2.2,0,4.1,0.2,5.7,0.4V42.7z"></path>
          <path class="st4" d="M538.1,56.9c4.8-1.9,9.2-3,14.3-3c10.7,0,14.4,5.2,14.4,14.8V84h-8.4V68.7c0-7.3-1.6-9.8-6-9.8
        c-2.2,0-4.6,0.5-6,0.9V84h-8.2V56.9z"></path>
          <path class="st4" d="M582.2,47.7v7h6.6v5h-6.6v14.7c0,3.4,0.3,4.7,1.7,4.9c1.3,0.2,2.6,0,4.8-0.2l1,4.9c-3.6,0.7-6.2,0.7-7.5,0.7
        c-7.3,0-8.6-3.4-8.6-10.3V59.7h-5.1v-5h5.1v-7H582.2z"></path>
          <path class="st4" d="M525.8,66.7c-0.2-5.9-1.9-7.7-5.9-7.7c-3.8,0-5.5,1.8-5.7,7.7H525.8z M533.1,83.2c-4.5,0.9-8.7,1.5-12.8,1.5
        c-12.4,0-14.9-6.5-14.9-15.4c0-11.3,5.2-15.3,14.2-15.3c9.6,0,14.6,4.5,14.6,14.3v3.4h-20.1c0.2,5.5,1.4,7.9,6.2,7.9
        c2.8,0,8.8-0.8,11.8-1.4L533.1,83.2z"></path>
          <path class="st4" d="M611.2,66.7c-0.2-5.9-1.9-7.7-5.9-7.7c-3.8,0-5.5,1.8-5.7,7.7L611.2,66.7z M618.5,83.2
        c-4.6,1-8.7,1.5-12.8,1.5c-12.4,0-14.9-6.5-14.9-15.4C590.9,58,596.1,54,605,54c9.6,0,14.6,4.5,14.6,14.3v3.4h-20.1
        c0.2,5.5,1.4,7.9,6.2,7.9c2.8,0,8.8-0.8,11.8-1.4L618.5,83.2z"></path>
        </g>
      </svg>
    </a>

    <div class="nav-shape"></div>
  </span>


</mat-toolbar>

<div class="container-garantia" role="main">
  <router-outlet></router-outlet>
</div>
<app-spinner></app-spinner>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

